import BellFilled from './BellFilled';
import BellOutlineThick from './BellOutlineThick';
import BellOutlineThin from './BellOutlineThin';

export default function NotifyMeBell({
  variant
}: {
  variant: 'thick' | 'thin' | 'filled';
}) {
  switch (variant) {
    case 'filled':
      return <BellFilled height="14" width="12" />;
    case 'thick':
      return <BellOutlineThick height="14" width="12" />;
    case 'thin':
      return <BellOutlineThin fill="black" height="20" width="20" />;
  }
}
